import React from "react";
import { Link } from "react-router-dom";
import { colours } from "styling/colours";
import { classes, style } from "typestyle";

type TextLinkProps = {
  to: string;
  children: string | React.ReactNode;
  className?: string;
  id?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
};

export const TextLink = (props: TextLinkProps) => {
  return (
    <Link
      className={classes(linkStyle, props.className)}
      to={props.to}
      onClick={props.onClick}
      id={props.id || "link"}
    >
      {props.children}
    </Link>
  );
};

const linkStyle = style({
  color: colours.link,
  $nest: {
    "&:hover": {
      color: colours.secondary,
      textDecoration: "underline",
    }
  }
});